import { TrustedIpsForm } from 'entities/settings/trusted-ips/trusted-ips.form';

export const CommonSettingsTab = () => {
  return <TrustedIpsForm />;
};
